import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const SmartphoneOutline = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M14.3824 17.4327C14.6585 17.4327 14.8824 17.2088 14.8824 16.9327C14.8824 16.6565 14.6585 16.4327 14.3824 16.4327V16.9327V17.4327ZM9.61765 16.4327C9.3415 16.4327 9.11765 16.6565 9.11765 16.9327C9.11765 17.2088 9.3415 17.4327 9.61765 17.4327V16.9327V16.4327ZM15 4.875V5.375V4.875ZM9 4.875V4.375V4.875ZM7.5 17.625L8 17.625V17.625L7.5 17.625ZM7.5 6.375H7V6.375H7.5ZM15 19.125V18.625V18.625V19.125ZM9 19.125V19.625V19.625V19.125ZM16.5 17.625L17 17.625V17.625L16.5 17.625ZM16.5 6.375L16 6.375V6.375L16.5 6.375ZM15 4.875V4.375L9 4.375V4.875V5.375L15 5.375V4.875ZM7.5 17.625L8 17.625L8 6.375L7.5 6.375H7L7 17.625H7.5ZM15 19.125V18.625H9V19.125V19.625H15V19.125ZM16.5 17.625L17 17.625L17 6.375L16.5 6.375L16 6.375L16 17.625L16.5 17.625ZM15 19.125V19.625C16.1045 19.625 17 18.7296 17 17.625L16.5 17.625L16 17.625C16 18.1773 15.5523 18.625 15 18.625V19.125ZM15 4.875V5.375C15.5523 5.375 16 5.82272 16 6.375L16.5 6.375L17 6.375C17 5.27043 16.1046 4.375 15 4.375V4.875ZM9 4.875V4.375C7.89543 4.375 7 5.27043 7 6.375H7.5L8 6.375C8 5.82271 8.44772 5.375 9 5.375V4.875ZM7.5 17.625H7C7 18.7296 7.89543 19.625 9 19.625V19.125L9 18.625C8.44772 18.625 8 18.1773 8 17.625L7.5 17.625ZM9.61765 16.9327V17.4327H14.3824V16.9327V16.4327H9.61765V16.9327Z" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper {...props} variant="solid">{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { SmartphoneOutline };